// Mutations
export const SET_TRANSLATES = 'SET_TRANSLATES';
export const SET_CURRENT_TRANSLATIONS_FOR = 'SET_CURRENT_TRANSLATIONS_FOR';

// Both
export const SET_LANGUAGE = 'SET_LANGUAGE';
